// Suggested prompt chips for Ask Hopscotch (spec: 4 per surface).
// General prompts show on Home and anywhere without an open set; set
// prompts show on a set's canvas and name a real game from the set when
// the guide's games are known.

export interface PromptGame {
  name: string
}

export function getGeneralPrompts(learnerName?: string | null): string[] {
  const name = learnerName?.trim() || 'my child'
  return [
    `How is ${name} doing?`,
    'What should we read next?',
    `How do I play a game with ${learnerName?.trim() ? name : 'them'}?`,
    'What does “Growth” mean?',
  ]
}

export function getSetPrompts(
  learnerName: string | null | undefined,
  games: PromptGame[],
): string[] {
  const name = learnerName?.trim() || 'my child'
  const firstGame = games[0]?.name
  return [
    'What skills does this set build?',
    firstGame ? `How do I play ${firstGame}?` : 'How do I play these games?',
    `Is this the right level for ${name}?`,
    games.length > 1 ? `Print all ${games.length} games` : 'Print this set',
  ]
}
